import { render } from "./CoAdminRight.vue?vue&type=template&id=0ed967c1"
import script from "./CoAdminRight.vue?vue&type=script&lang=js"
export * from "./CoAdminRight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__